import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { cloneObject } from '../../common/utils';

const getIconSet = function (iconName) {
  const { definitions } = library;
  const iconSets = Object.keys(definitions);
  return iconSets.find(iconSet => definitions[iconSet][iconName]);
};

const Icon = props => {
  const { iconName, className } = props;
  const passedProps = cloneObject(props, {}, ['iconName']);
  const classNames = className ? className.split(' ') : [];

  classNames.push('icon');
  passedProps.className = classNames.join(' ');

  return <FontAwesomeIcon icon={[getIconSet(iconName), iconName]} {...passedProps} />;
};

Icon.propTypes = {
  iconName: PropTypes.string.isRequired
};

export default Icon;